import { workflowAxiosGet } from "../utils/workflowAuthHeaders";

const fetchTabPreco = async (codTabelaCliente, token, username, password) => {
  const baseUrl = "https://workflow.grupocenze.com.br:38137/rest/";
  const apiUrl = `${baseUrl}TABPRECO`;

  try {
    const response = await workflowAxiosGet(
      apiUrl,
      {
        params: {
          grupo_cli: "010"
        }
      },
      { token, username, password }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching tab preco:", error);
    throw error;
  }
};

export default fetchTabPreco;
